var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.00003V2.21003C12 1.76003 11.46 1.54003 11.15 1.86003L7.35003 5.65003C7.15003 5.85003 7.15003 6.16003 7.35003 6.36003L11.14 10.15C11.46 10.46 12 10.24 12 9.79003V7.00003C15.73 7.00003 18.68 10.42 17.86 14.29C17.39 16.56 15.55 18.39 13.29 18.86C9.72003 19.61 6.54003 17.16 6.06003 13.85C5.99003 13.37 5.57003 13 5.08003 13C4.48003 13 4.00003 13.53 4.08003 14.13C4.70003 18.52 8.88003 21.77 13.61 20.85C16.73 20.24 19.24 17.73 19.85 14.61C20.84 9.48003 16.94 5.00003 12 5.00003Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.b45ebb02a8f7ea81c128c14ed98e7fdc.svg";
export { ForwardRef as ReactComponent };